import React from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { getToken, simpleAlert, triggerAlert } from '../utils';
import { useState } from 'react';
import { useEffect } from 'react';
import Cookies from "js-cookie";
const fetchData = async (status, searchKey) => {
  const api_url = process.env.REACT_APP_API_BASE_URL;
  const token = Cookies.get('admin_user_token');
  //console.log(status);

  try {
    let apiUrl = `apiV1/active-customers-dropdown/`;
    let params = ``;
    if (status) params += `&customer_status=${status}`;
    if (searchKey) params += `&keyword=${searchKey}`;

    //console.log(apiUrl + params);
    //if (searchQuery) params += `&keyword=${searchQuery}`;

    const response = await axios.get(apiUrl + params);
     
    const response_data = response.data;

    if (response_data.error_code === 200) {
      const users = response_data
      //console.log(users);
      return users.map(user => ({
        value: user.id,
        user: user.contact_person,
        label:  user.company_name,
        m4_account_id: user.m4_account_id,
      }));
    } else if (response.status === 204) {
      simpleAlert('No Data Available!');
    } else {
      triggerAlert('error', 'Oops...', "Couldn't get the user details");
    }
  } catch (error) {
    console.error('Error loading user options:', error);
    return [];
  }
};

const fetchUserData = async (searchKey = '') => {
  const api_url = process.env.REACT_APP_API_BASE_URL;
  const token = Cookies.get('admin_user_token'); 
  try {
    let apiUrl = `apiV1/active-customers-dropdown/`;
    let params = ``;

    const response = await axios.get(apiUrl + params, token);
    
    const response_data = response.data;

    if (response_data.error_code === 200) {
      const users = response_data
      return users.map(user => ({
        value: user.id,
        user: user.contact_person,
        label:  user.company_name,
        m4_account_id: user.m4_account_id,
      }));
    } else if (response.status === 204) {
      simpleAlert('No Data Available!');
    } else {
      triggerAlert('error', 'Oops...', "Couldn't get the user details");
    }
  } catch (error) {
    console.log(error);
    console.error('Error loading user options:', error);
    return [];
  }
}

const getLabelBasedOnSearch = (user, searchKey) => {
  // Example condition: if user's company name starts with the input value, use it; otherwise, use the user name
  if (user.company_name.toLowerCase().includes(searchKey.toLowerCase()) || user.user_name.toLowerCase().includes(searchKey.toLowerCase())) {
    return user.user_name + ', ' + user.company_name.substring(0, 10);
  }
  // You can modify this logic based on your specific conditions for labeling
};

const AutoCompanyUserSearch = ({ status, searchKey, onSelect, userId = '' }) => {
  const [userOptions, setUserOptions] = useState([]);
  const [usersOptions, setUsersOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  //console.log(userId);
  useEffect(() => {
    // Fetch initial data when the component mounts
    fetchData(status, searchKey).then(options => setUserOptions(options));
    fetchUserData()
      .then(options => {
        setUsersOptions(options);
        if (userId) {
          //console.log(userId);
          const optionSel1 = options.find((option) => option.m4_account_id == userId);
          setSelectedOption(optionSel1);
        } else {
          setSelectedOption('');
        }
      })
      .catch(error => console.error('Error fetching user data:', error));
  }, [userId]); // Empty dependency array ensures it only runs once on mount

  // const loadOptions = (inputValue, callback) => {
  //   // Use the locally stored options if available
  //   //fetchData(status, inputValue).then(options => setUserOptions(options));
  //   const filteredUsers = userOptions.filter(user =>
  //     user.label.toLowerCase().includes(inputValue.toLowerCase())
  //   );
  //   callback(filteredUsers);
  // };

  const loadOptions = (inputValue, callback) => {
    fetchData(status, inputValue).then(options => {
      if (options === undefined) {
        setUserOptions('');
      } else {
        setUserOptions(options);
        const filteredUsers = options.filter(user =>
          // Create an array of fields/labels to search within the user object
          ['label', 'user'].some(field =>
            user[field]?.toLowerCase().includes(inputValue.toLowerCase())
          )
        );
        callback(filteredUsers);
      }
    });
  };

  const handleSelect = (selectedOption) => {
    if (onSelect) {
      if (selectedOption) {
        onSelect({
          user_id: selectedOption.value,
          user: selectedOption.user,
          user_m4_account_id: selectedOption.m4_account_id,
        });
        if (selectedOption.m4_account_id) {
          const optionSel = usersOptions.find((option) => option.m4_account_id == selectedOption.m4_account_id);
          setSelectedOption(optionSel);
        } else {
          const optionSel = usersOptions.find((option) => option.value == selectedOption.value);
          setSelectedOption(optionSel);
        }
      } else {
        onSelect({
          user_id: '',
          user: '',
          user_m4_account_id: '',
        });
        setSelectedOption('');
      }
    }
  };


  //console.log(selectedOption);

  return (
    <AsyncSelect
      isClearable // to clear selected option
      cacheOptions
      loadOptions={loadOptions}
      defaultOptions={userOptions}
      onChange={handleSelect}
      value={selectedOption || null}
      placeholder='Search Username or Company'
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          border: state.isSelected ? '1px solid #e9e9ef' : '1px solid #e9e9ef',
          boxShadow: state.isHovered ? '1px solid #e9e9ef' : '1px solid #e9e9ef',
          background: '#f8f9fa',
          color: '#000'
        }),
      }}
    />
  );
};

export default AutoCompanyUserSearch;
